import { NavigateOptions, URLSearchParamsInit } from 'react-router-dom';

import { TableProps } from 'antd';

import { EPaginationParams } from 'features/Pagination';

export const getTableSorter =
	<T>(
		searchParams: URLSearchParams,
		setSearchParams: (
			nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
			navigateOpts?: NavigateOptions,
		) => void,
	): TableProps<T>['onChange'] =>
	(_, __, sorter) => {
		if (!Array.isArray(sorter)) {
			if (!sorter?.order) {
				searchParams.delete('ordering');
			} else {
				if (sorter.field === 'date_time') sorter.field = 'date';
				const sortField = !sorter.field ? '' : sorter.order === 'ascend' ? sorter.field : '-' + sorter.field;
				searchParams.set('ordering', sortField.toString());
			}

			searchParams.delete(EPaginationParams.OFFSET);
			setSearchParams(searchParams);
		}
	};
